import identityStyles from "./heroidentity.module.scss"

export default ({
  appId,
  redirectUrl,
  loginUrl = "https://account.collegeboard.org/login/login",
  createAccountUrl = "https://account.collegeboard.org/login/signUp",
  heroBackgroundImageUrl = "",
  heroContentText = "",
  identityDesc = "",
}) => (
  <div
    id="cb-atlas-identity-2"
    data-cbtrack-widget="identity"
    className={`${identityStyles["cb-widget"]} ${identityStyles.root} cb-apricot3`}
  >
    <div className={identityStyles.background} />
    <div>
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-6 col-lg-5 col-lg-offset-1">
            <div className={identityStyles.hero}>
              <img
                className="transition "
                src={heroBackgroundImageUrl}
                alt=""
              />
              <div className={identityStyles.content}>
                {heroContentText ? <h2>{heroContentText}</h2> : null}
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-sm-6 col-md-offset-1 col-md-5">
            <div className={identityStyles["cb-wg-identity-card"]}>
              <div className={identityStyles["cb-wg-identity-card-container"]}>
                <h2 className="cb-roboto-slab-bold">Sign In</h2>
                <p className={identityStyles["cb-wg-margin-top-8"]}>
                  {identityDesc}
                </p>
                <div className={identityStyles["login-flow-button"]}>
                  <a
                    href={`${loginUrl}?appId=${appId}&idp=EPL&skipEnroll=Y&DURL=${redirectUrl}`}
                    className={`btn btn-sm btn-primary ${identityStyles["cb-wg-margin-top-16"]}`}
                  >
                    Continue
                  </a>
                </div>
                <div
                  className={`${identityStyles["cb-wg-margin-top-32"]} ${identityStyles["cb-wg-padding-top-16"]} ${identityStyles["cb-wg-border-top-dashed-1"]}`}
                >
                  <p className="cb-margin-top-8">Don&#39;t have an account?</p>
                  <a
                    href={`${createAccountUrl}?appId=${appId}&DURL=${redirectUrl}`}
                    className={identityStyles["cb-wg-link-black"]}
                  >
                    Create Account
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)
